import * as React from 'react';
import { FC, SVGProps } from 'react';

const Phone: FC<SVGProps<SVGSVGElement>> = props => (
    <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.30502 14.74C6.83002 12.46 3.69502 6.81498 3.03002 3.44498C3.00002 3.14998 3.00002 2.85498 3.22502 2.70498L5.94002 1.07498C5.99885 1.03739 6.0649 1.01255 6.13392 1.00204C6.20294 0.991526 6.2734 0.995587 6.34075 1.01396C6.4081 1.03233 6.47086 1.0646 6.52499 1.10869C6.57912 1.15279 6.62341 1.20773 6.65502 1.26998L8.22502 4.09498C8.29396 4.22054 8.31217 4.36774 8.2759 4.50632C8.23963 4.64489 8.15163 4.7643 8.03002 4.83998L7.12502 5.37998C7.00425 5.45645 6.91729 5.57621 6.88196 5.71472C6.84664 5.85323 6.86562 6.00001 6.93502 6.12498L9.02502 9.88998C9.05662 9.95223 9.10092 10.0072 9.15504 10.0513C9.20917 10.0954 9.27193 10.1276 9.33928 10.146C9.40664 10.1644 9.47709 10.1684 9.54611 10.1579C9.61513 10.1474 9.68118 10.1226 9.74002 10.085L10.645 9.54498C10.7042 9.50757 10.7705 9.48299 10.8397 9.47284C10.909 9.46269 10.9796 9.46718 11.047 9.48603C11.1144 9.50488 11.1771 9.53767 11.231 9.58228C11.2849 9.62688 11.3289 9.68231 11.36 9.74498L12.93 12.565C12.9994 12.6899 13.0184 12.8367 12.9831 12.9752C12.9477 13.1137 12.8608 13.2335 12.74 13.31L10 14.94C9.77002 15.09 9.52502 14.94 9.30502 14.74Z"
            fill="black"
        />
    </svg>
);

export default Phone;
